import FroalaEditor from 'froala-editor';

FroalaEditor.PLUGINS.closeEditorWithShortcut = function (editor) {
  return {
    _init: function () {
      const closeCallback = editor.opts.onCloseRequest;

      // only register the shortcut if there is a close callback available
      if (closeCallback != null) {
        editor.events.on(
          'keydown',
          function (e) {
            const ctrlKey = editor.helpers.isMac() ? e.metaKey : e.ctrlKey;
            if (e.keyCode === 13 && ctrlKey) {
              closeCallback();
              return false;
            }
          },
          true
        );
      }
    },
  };
};
